import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { BOXIDS } from "src/configs/ticket";
import BoxSaleContract from "src/contract-logic/logic/BoxSaleContract";

const initialState = {
  price: undefined,
  balance: undefined,
  presalePrice: undefined,
  ticketInBox: undefined,
  ticketLimit: undefined,
  ticketSold: undefined,
  boxLimits: undefined,
  boxSolds: undefined,
};

export const getPriceOfBoxSale = createAsyncThunk("boxSaleSlice/getPriceOfBoxSale", async () => {
  let price = await Promise.all(BOXIDS.map((i) => BoxSaleContract.getBoxPrice(i)));
  return price
    .map((p) => BigNumber(p).dividedBy(BASE18).toNumber())
    .reduce((result, i, index) => {
      result[BOXIDS[index]] = i;
      return result;
    }, {});
});

export const getBalance = createAsyncThunk("boxSaleSlice/getBalance", async (_, thunkAPI) => {
  const accountAddress = thunkAPI.getState().accountSlice.address;
  const balance = await Promise.all(BOXIDS.map((i) => BoxSaleContract.getBalance(accountAddress, i)));
  return balance.reduce((result, i, index) => {
    result[BOXIDS[index]] = i;
    return result;
  }, {});
});

export const getRemainingPresale = createAsyncThunk("boxSaleSlice/getRemainingPresale", async (_) => {
  const [ticketLimit, ticketSold] = await Promise.all([
    BoxSaleContract.getTicketLimit(),
    BoxSaleContract.getTicketSold(),
  ]);
  return { ticketLimit, ticketSold };
});

export const getRemainBox = createAsyncThunk("boxSaleSlice/getRemainBox", async (_) => {
  let boxLimits = await Promise.all(BOXIDS.map((i) => BoxSaleContract.getBoxLimitForId(i)));
  boxLimits = boxLimits.reduce((result, i, index) => {
    result[BOXIDS[index]] = i;
    return result;
  }, {});
  let boxSolds = await Promise.all(BOXIDS.map((i) => BoxSaleContract.getBoxSoldForId(i)));
  boxSolds = boxSolds.reduce((result, i, index) => {
    result[BOXIDS[index]] = i;
    return result;
  }, {});
  return { boxLimits, boxSolds };
});

export const getPresalePrice = createAsyncThunk("boxSaleSlice/getPresalePrice", async (_) => {
  const presalePrice = await BoxSaleContract.getPresalePrice();
  return BigNumber(presalePrice).dividedBy(BASE18).toNumber();
});

export const getTicketInBox = createAsyncThunk("boxSaleSlice/getTicketInBox", async (_) => {
  const ticketInBox = await Promise.all(BOXIDS.map((i) => BoxSaleContract.getTicketInBox(i)));
  return ticketInBox.reduce((result, i, index) => {
    result[BOXIDS[index]] = i;
    return result;
  }, {});
});

const boxSaleSlice = createSlice({
  name: "boxSaleSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getPriceOfBoxSale.fulfilled, (state, action) => {
        state.price = action.payload;
      })
      .addCase(getBalance.fulfilled, (state, action) => {
        state.balance = action.payload;
      })
      .addCase(getPresalePrice.fulfilled, (state, action) => {
        state.presalePrice = action.payload;
      })
      .addCase(getTicketInBox.fulfilled, (state, action) => {
        state.ticketInBox = action.payload;
      })
      .addCase(getRemainingPresale.fulfilled, (state, action) => {
        state.ticketSold = action.payload.ticketSold;
        state.ticketLimit = action.payload.ticketLimit;
      })
      .addCase(getRemainBox.fulfilled, (state, action) => {
        state.boxLimits = action.payload.boxLimits;
        state.boxSolds = action.payload.boxSolds;
      }),
});

export default boxSaleSlice.reducer;
export const selectBoxSlice = (state) => state.boxSaleSlice;
